var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56659 5.26608V10.3961H12.5297V14.9466H5.56659V25H0.691895V2.25761C0.691895 1.02298 1.17228 0.546766 2.40613 0.546766H13.9406V5.26608H5.56659Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.583 25V2.25761C15.583 1.0255 16.0685 0.546766 17.3023 0.546766H20.4577V25H15.583Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6791 7.65731C32.6791 9.64279 31.5135 10.633 29.8296 10.633H27.7007V4.67908H29.8296C31.5135 4.67908 32.6791 5.67434 32.6791 7.65731ZM37.6549 18.0206C37.6549 14.7023 35.8699 13.1325 34.5652 12.684C35.7308 12.1423 37.483 10.7716 37.483 7.00724C37.483 3.58807 35.1493 0.544325 30.1709 0.544325H24.649C23.4126 0.544325 22.9297 1.02306 22.9297 2.25517V24.9976H30.3783C34.5652 24.9976 37.6549 22.6694 37.6549 18.0206ZM32.7448 17.751C32.7448 19.802 31.5464 20.7948 29.8625 20.7948H27.7007V14.7023H29.8625C31.5464 14.7023 32.7448 15.695 32.7448 17.751Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1508 12.2102H44.6225V7.18101C44.6225 6.15299 44.9638 4.4094 46.8879 4.4094C48.8095 4.4094 49.1508 6.15299 49.1508 7.18101V12.2102ZM54.0255 25V6.63173C54.0255 4.75207 52.9965 0 46.8879 0C40.7743 0 39.7478 4.75207 39.7478 6.63173V25H44.6225V16.7582H49.1508V25H54.0255Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiba);
export default __webpack_public_path__ + "static/media/fiba.d7462a3564c8b9e4b1bf393ac7434104.svg";
export { ForwardRef as ReactComponent };